// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"html__wrapper__HHB8H","asterisk":"html__asterisk__xbEVB","background":"html__background__VxRQh"};